module.exports = __webpack_public_path__ + "static/img/28dbcd2b-ab97-4b52-a47f-bbf62c741ca7.c3d1b5ae.png";